import { render, staticRenderFns } from "./freeGameToken.vue?vue&type=template&id=57c079de&lang=pug"
import script from "./freeGameToken.vue?vue&type=script&lang=js"
export * from "./freeGameToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports